var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "background-color": "#1EB11A",
      "height": "100vh",
      "width": "100vw"
    }
  }, [_vm.displayLoading ? _c('loading') : _vm._e(), _c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "https://storage.googleapis.com/waltily-prod/elancotw/inline_open_0415.jpg",
      "alt": ""
    },
    on: {
      "click": function click() {
        return _vm.goto();
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }